import { useGetPermissionsQuery } from '../../../api/permissionsApi';
import { useAppSelector } from '../store';
import { getSelectedSiteCollaborateInfo } from '../store/siteInfoSlice';

export const usePermissions = () => {
  const runPermissions = false;
  const itemDetails = useAppSelector(getSelectedSiteCollaborateInfo);
  const role = itemDetails?.result?.role ?? '';
  const { data: permissionsData } = useGetPermissionsQuery(
    { role: role },
    { skip: !role || !runPermissions, refetchOnMountOrArgChange: false }
  );

  const rolePermissions = permissionsData?.permissions;
  const permissions = rolePermissions?.permissions ?? [];

  const isPermitted = (permissionName: string): boolean => {
    if (!runPermissions) {
      return true;
    }
    const trimmedPermissionName = permissionName.toLowerCase().trim();
    const permission = permissions.find(
      (permission) => permission.permission === trimmedPermissionName
    );

    if (!permission) {
      return true;
    }
    return Boolean(permission.value) || permission.value === 'true';
  };

  return {
    permissionsData,
    permissions,
    isPermitted,
  };
};
